import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { commonActions, contracterActions, sentActions, alertActions } from '../../../../store/actions'

import CertificateList from './CertificateSentList'
import Calendar from '../../../../module/component-box/Calendar'
import queryString from 'query-string'
import Pagination from '../../../../module/pagination-box'
import history from '../../../../route/history'
import Loading from '../../../../module/loading/Loading'

const CertificateSentMain = (props) => {
  const [state, setState] = useState({
    isHelp: false,
  })

  const [searchWord, setSearchWord] = useState('')
  const [tempFrom, setTempFrom] = useState('')
  const [tempTo, setTempTo] = useState('')

  const [searchInfo, setSearchInfo] = useState([])

  const [tabId, setTabId] = useState('99')

  // const [toggle, setToggle] = useState({
  //   isSearchType: false,
  //   isDocType: false,
  // })
  const [countInfo, setCountInfo] = useState({
    countALL: 0,
    count01: 0,
    count02: 0,
    count03: 0,
    count04: 0,
    count10: 0,
    count11: 0,
    count12: 0,
    count13: 0,
  })

  const [pagingInfo, setPagingInfo] = useState({})
  const [printList, setPrintList] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    props.common({ mainCd: ['CRT_STS_CD', 'CRT_DV', 'CRT_SUBMIS_TP'] })

    const query = queryString.parse(history.location.search)
    const state = queryString.parse(history.location.state)

    console.log('query', query)
    console.log('state', state)

    selectDay('Y1')

    if (Object.keys(query).length > 0) {
      props.settingHistory(query)

      const tmpSearchInfo = [
        { type: 'tabStatus', value: query.tabStatus },
        { type: 'srhKind', value: query.srhKind },
        { type: 'srhPrchsNm', value: query.srhPrchsNm },
        { type: 'searchWord', value: query.searchWord },
        { type: 'srhFrom', value: query.srhFrom },
        { type: 'srhTo', value: query.srhTo },
        { type: 'srhOrder', value: query.srhOrder },
        { type: 'srhBy', value: query.srhBy },
      ]
      console.log('tmpSearchInfo', tmpSearchInfo)

      setSearchInfo(tmpSearchInfo)
      searchList(tmpSearchInfo)
      if (query.searchWord) {
        setSearchWord(query.searchWord)
      }
    } else if (Object.keys(state).length > 0) {
      props.settingHistory(state)

      const tmpSearchInfo = [
        { type: 'tabStatus', value: state.tabStatus },
        { type: 'srhKind', value: state.srhKind },
        { type: 'srhPrchsNm', value: state.srhPrchsNm },
        { type: 'searchWord', value: state.searchWord },
        { type: 'srhFrom', value: state.srhFrom },
        { type: 'srhTo', value: state.srhTo },
        { type: 'srhOrder', value: state.srhOrder },
        { type: 'srhBy', value: state.srhBy },
      ]
      console.log('tmpSearchInfo', tmpSearchInfo)

      setSearchInfo(tmpSearchInfo)
      searchList(tmpSearchInfo)
      if (state.searchWord) {
        setSearchWord(state.searchWord)
      }
    } else {
      searchList(searchInfo)
    }

    return () => {
      props.changeSearchInfo(null) // 이전 검색 초기화
    }
  }, [])

  useEffect(() => {
    // count갯수 설정...
    setCountInfo({
      ...countInfo,
      countALL: props.countInfo?.ALL,
      count01: props.countInfo?.['01'],
      count02: props.countInfo?.['02'],
      count03: props.countInfo?.['03'],
      count04: props.countInfo?.['04'],
      count10: props.countInfo?.['10'],
      count11: props.countInfo?.['11'],
      count12: props.countInfo?.['12'],
      count13: props.countInfo?.['13'],
    })
  }, [props.countInfo])

  useEffect(() => {
    if (props.commoncode.length < 1) return
  }, [props.commoncode])

  useEffect(() => {
    if (props.soloSelectInfo === null || props.soloSelectInfo === undefined) return
    let arr = searchInfo.filter((info) => info.type !== props.soloSelectInfo?.type)

    arr.push(props.soloSelectInfo)
    setSearchInfo(arr)
    searchList(arr)
  }, [props.soloSelectInfo])

  useEffect(() => {
    const tRs = props.SentList?.totalElements ? props.SentList?.totalElements : 0
    const tPage = Math.ceil(tRs / 10)
    setPagingInfo({
      totalRecords: props.SentList?.totalElements ? props.SentList?.totalElements : 0,
      currentPage: state.pageIdx ? parseInt(state.pageIdx) + 1 : 1,
      pageNumber: props.SentList?.pageable?.pageNumber,
      totalPage: tPage,
      pagesToShow: 10,
    })

    setPrintList(props.SentList?.content)
    if (props.SentList) {
      setLoading(false)
    }
  }, [props.SentList])

  useEffect(() => {
    if (!props.history) return

    const idx = props.history?.pageIdx ? props.history?.pageIdx : 0

    searchList(null, idx)
  }, [props.history])

  const searchTabInfo = [
    {
      title: '전체',
      id: '99',
      count: countInfo.countALL,
    },
    {
      title: '제출',
      id: '10',

      count: countInfo?.count10,
    },
    {
      title: '반려',
      id: '11',
      count: countInfo?.count11,
    },
    {
      title: '수취완료',
      id: '12',
      count: countInfo?.count12,
    },
    {
      title: '회수',
      id: '13',
      count: countInfo?.count13,
    },
  ]

  const onSelected = (e, type, value) => {
    if (type === 'tabStatus') {
      return props.changeSearchInfo({ type, value })
    } else if (type === 'srhOrder') {
      if (searchInfo.find((s) => s.type === 'srhBy')?.value === 'desc') {
        setSearchInfo([
          { type: 'tabStatus', value: searchInfo.find((s) => s.type === 'tabStatus')?.value || '' },
          { type: 'srhKind', value: searchInfo.find((s) => s.type === 'srhKind')?.value || '' },
          { type: 'srhPrchsNm', value: searchInfo.find((s) => s.type === 'srhPrchsNm')?.value || '' },
          { type: 'searchWord', value: searchInfo.find((s) => s.type === 'searchWord')?.value || '' },
          { type: 'srhFrom', value: searchInfo.find((s) => s.type === 'srhFrom')?.value || '' },
          { type: 'srhTo', value: searchInfo.find((s) => s.type === 'srhTo')?.value || '' },
          { type: 'srhOrder', value: value },
          { type: 'srhBy', value: 'asc' },
        ])
        return searchList(searchInfo)
        //return props.changeSearchInfo([{ type, value},{type: 'srhBy', value: 'asc'}])
      } else {
        setSearchInfo([
          { type: 'tabStatus', value: searchInfo.find((s) => s.type === 'tabStatus')?.value || '' },
          { type: 'srhKind', value: searchInfo.find((s) => s.type === 'srhKind')?.value || '' },
          { type: 'srhPrchsNm', value: searchInfo.find((s) => s.type === 'srhPrchsNm')?.value || '' },
          { type: 'searchWord', value: searchInfo.find((s) => s.type === 'searchWord')?.value || '' },
          { type: 'srhFrom', value: searchInfo.find((s) => s.type === 'srhFrom')?.value || '' },
          { type: 'srhTo', value: searchInfo.find((s) => s.type === 'srhTo')?.value || '' },
          { type: 'srhOrder', value: value },
          { type: 'srhBy', value: 'desc' },
        ])
        return searchList(searchInfo)
      }
    } else if (type === 'srhKind') {
      return props.changeSearchInfo({ type, value })
    } else if (type === 'srhFrom') {
      setSearchInfo([
        { type: 'tabStatus', value: searchInfo.find((s) => s.type === 'tabStatus')?.value || '' },
        { type: 'srhKind', value: searchInfo.find((s) => s.type === 'srhKind')?.value || '' },
        { type: 'srhPrchsNm', value: searchInfo.find((s) => s.type === 'srhPrchsNm')?.value || '' },
        { type: 'searchWord', value: searchInfo.find((s) => s.type === 'searchWord')?.value || '' },
        { type: 'srhFrom', value: value },
        { type: 'srhTo', value: searchInfo.find((s) => s.type === 'srhTo')?.value || '' },
        { type: 'srhOrder', value: searchInfo.find((s) => s.type === 'srhOrder')?.value || '' },
        { type: 'srhBy', value: searchInfo.find((s) => s.type === 'srhBy')?.value || ''  },
      ])
      return setTempFrom(value)
    } else if (type === 'srhTo') {
      setSearchInfo([
        { type: 'tabStatus', value: searchInfo.find((s) => s.type === 'tabStatus')?.value || '' },
        { type: 'srhKind', value: searchInfo.find((s) => s.type === 'srhKind')?.value || '' },
        { type: 'srhPrchsNm', value: searchInfo.find((s) => s.type === 'srhPrchsNm')?.value || '' },
        { type: 'searchWord', value: searchInfo.find((s) => s.type === 'searchWord')?.value || '' },
        { type: 'srhFrom', value: searchInfo.find((s) => s.type === 'srhFrom')?.value || '' },
        { type: 'srhTo', value: value },
        { type: 'srhOrder', value: searchInfo.find((s) => s.type === 'srhOrder')?.value || '' },
        { type: 'srhBy', value: searchInfo.find((s) => s.type === 'srhBy')?.value || ''  },
      ])
      return setTempTo(value)
    }

    if (type !== 'searchWord') {
      setSearchInfo(
        searchInfo.map((info) =>
          info.type === type
            ? {
                type,
                value: moment(value).format('Y-MM-DD'),
              }
            : info,
        ),
      )
    } else {
      if (
        (searchInfo.find((s) => s.type === 'srhFrom')?.value !== '' && searchInfo.find((s) => s.type === 'srhTo')?.value !== '') ||
        (searchInfo.find((s) => s.type === 'srhFrom')?.value !== 'undefined' &&
          searchInfo.find((s) => s.type === 'srhTo')?.value !== 'undefined')
      ) {
        if (searchInfo.find((s) => s.type === 'srhFrom')?.value > searchInfo.find((s) => s.type === 'srhTo')?.value) {
          return props.error({ message: '기간설정을 다시 입력해주세요.' })
        } else if (tempFrom > tempTo) {
          return props.error({ message: '기간설정을 다시 입력해주세요.' })
        } else {
          if (type === 'searchWord') {
            return props.changeSearchInfo({ type, value })
          } else {
            return searchList(searchInfo)
          }
        }
      } else {
        if (type === 'searchWord') {
          return props.changeSearchInfo({ type, value })
        } else {
          return searchList(searchInfo)
        }
      }
    }
  }

  const searchList = (searchInfo, index = 0) => {
    let sendSearch = {}

    if (searchInfo === null) {
      // history 남아있을시
      sendSearch = {
        srhFrom: props.history?.srhFrom,
        srhTo: props.history?.srhTo,
        srhKind: props.history?.srhKind,
        tabStatus: props.history?.tabStatus ? props.history?.tabStatus : '99',
        srhOrder: props.history?.srhOrder ? props.history?.srhOrder : '',
        srhBy: props.history?.srhBy ? props.history?.srhBy : 'desc',
        searchWord: props.history?.searchWord ? props.history?.searchWord : '',
      }
    } else {
      sendSearch = {
        srhFrom: searchInfo.find((s) => s.type === 'srhFrom')?.value || '',
        srhTo: searchInfo.find((s) => s.type === 'srhTo')?.value || '',
        srhKind: searchInfo.find((s) => s.type === 'srhKind')?.value || '',
        tabStatus: searchInfo.find((s) => s.type === 'tabStatus')?.value || '',
        srhOrder: searchInfo.find((s) => s.type === 'srhOrder')?.value || '',
        srhBy: searchInfo.find((s) => s.type === 'srhBy')?.value || '',
        searchWord: searchInfo.find((s) => s.type === 'searchWord')?.value || '',
      }
    }

    sendSearch.pageIdx = index

    setState({
      ...state,
      ...sendSearch,
    })

    if (searchInfo?.find((s) => s.type === 'srhFrom')?.value > searchInfo?.find((s) => s.type === 'srhTo')?.value) {
      return props.error({ message: '기간설정을 다시 입력해주세요.' })
    }

    let paramStr = queryString.stringify(sendSearch)
    paramStr.length > 0 && (paramStr = '?' + paramStr)
    history.push('/service/sent' + paramStr)

    setLoading(true)
    props.readSentList(sendSearch)
  }

  const onSentDetail = (contract) => {
    const status = contract.sts

    props.selectSentInfo(contract) // 선택한 대상의 정보 셋팅
    if (status === '01') {
      // 임시저장 - 발급화면 호출
      window.location.href = '/service/certapply/1?seq=' + contract.crtRcvSeq
    } else if (status === '02' || status === '04') {
      // 전송완료,오류통보 - 발급화면 readonly상태로 호출
      history.push({ pathname: '/service/certapply/detail/' + contract.crtRcvSeq, state: state })
    } else if (status === '03' || status === '10' || status === '11' || status === '12' || status === '13') {
      // 발급완료, 제출완료, 수취완료, 반려 - 상세조회화면 조회로 호출
      // 발급완료, 제출완료, 수취완료, 반려 - 상세조회화면 조회로 호출
      if (contract.crtCd === '01') {
        history.push({ pathname: '/service/certapply/detail/' + contract.crtRcvSeq, state: state })
      } else {
        history.push({ pathname: '/service/certbox/detail/' + contract.crtRcvSeq, state: state })
      }
    }
  }

  const toggleHelp = () => {
    setState({ ...state, isHelp: !state.isHelp })
  }
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSelected(e, 'searchWord', searchWord)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    onSelected(e, name, value)
  }

  const selectDay = (type) => {
    const d = new Date()
    const year = d.getFullYear() // 년
    const month = d.getMonth() // 월
    const day = d.getDate() // 일

    let tdt = new Date(year, month, day)
    tdt = moment(tdt).format('Y-MM-DD')
    if (type === 'W1') {
      // 1주일
      let fdt = new Date(year, month, day - 7)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      // searchList(arr)
    } else if (type === 'M1') {
      // 1개월
      let fdt = new Date(year, month - 1, day)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      // searchList(arr)
    } else if (type === 'M3') {
      // 3개월
      let fdt = new Date(year, month - 3, day)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      // searchList(arr)
    } else if (type === 'M6') {
      // 6개월
      let fdt = new Date(year, month - 6, day)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      // searchList(arr)
    } else if (type === 'Y1') {
      // 1년
      let fdt = new Date(year - 1, month, day)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      // searchList(arr)
    } else {
      let arr = []
      arr.push({ type: 'srhFrom', value: '' })
      arr.push({ type: 'srhTo', value: '' })
      setTempFrom(null)
      setTempTo(null)
      setSearchInfo(arr)
      // searchList(arr)
    }
  }
  return (
    <>
      {/* contents */}
      {loading ? <Loading /> : null}
      <div id="contents">
        <div className="content-header">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault()
              window.history.back()
            }}
            className="page-prev"
          >
            뒤로이동
          </a>
          {/* mobile */}
          <h2>보낸문서</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>전자문서지갑</span>
            <em>보낸문서</em>
          </div>
        </div>

        <div className="search-box">
          <div className="row">
            <span className="tit">기간</span>
            <span className="datepicker">
              <Calendar
                onSelect={(value) => onSelected(null, 'srhFrom', value ? moment(value).format('Y-MM-DD') : '')}
                // default={searchInfo?.find((i) => i.type === 'srhFrom')?.value}
                default={tempFrom}
                title="처음날짜(발급일)"
              />
              <span className="split">~</span>
              <Calendar
                onSelect={(value) => onSelected(null, 'srhTo', value ? moment(value).format('Y-MM-DD') : '')}
                // default={searchInfo?.find((i) => i.type === 'srhTo')?.value}
                default={tempTo}
                title="마지막날짜(발급일)"
              />
            </span>
            <span className="form-date">
              <button type="button" className="btn-primary" onClick={() => selectDay('W1')}>
                1주일
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('M1')}>
                1개월
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('M3')}>
                3개월
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('M6')}>
                6개월
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('Y1')}>
                1년간
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('99')}>
                초기화
              </button>
            </span>
          </div>
          <div className="row">
            {/* <span className="tit">발급처</span>
              <select className="form-category" title="발급처" name="srhPrchsNm" id="srhPrchsNm" value={searchInfo?.find(i => i.type === 'srhPrchsNm')?.value || ''} onChange={handleChange}>
                <option value="" key={''}>전체</option>
                {
                  props.commoncode?.ISSU_INST_CD?.map((item) => (
                      <option key={item.cdName} value={item.cdName} defaultValue={searchInfo?.find(i => i.type === 'srhPrchsNm')?.value === item.cdName}>{item.cdName}</option>
                  ))
                }
              </select> */}
            <span className="tit">문서유형</span>
            <select
              className="form-category2"
              title="문서유형"
              name="srhKind"
              id="srhKind"
              value={searchInfo?.find((i) => i.type === 'srhKind')?.value || ''}
              onChange={handleChange}
            >
              <option value="" key={''}>
                전체
              </option>
              {props.commoncode?.CRT_DV?.map((item) => (
                <option key={item.cd} value={item.cd} defaultValue={searchInfo?.find((i) => i.type === 'srhKind')?.value === item.cd}>
                  {item.cdName}
                </option>
              ))}
            </select>
            <span className="tit">검색어</span>
            <div className="inquiry-group">
              <input
                type="text"
                title="발급번호를 입력하세요."
                placeholder="발급번호 또는 발급처를 입력하세요."
                className="form-keyword"
                id="searchWord"
                name="searchWord"
                value={searchWord}
                onChange={({ target }) => setSearchWord(target.value)}
                onKeyPress={handleKeyPress}
              />
              <button className="btn-search" onClick={(e) => onSelected(e, 'searchWord', searchWord)}>
                검색
              </button>
            </div>
          </div>
        </div>
        <div className="pc-only">
          <div className="tbl-wrap mt65">
            <table className="tbl-list">
              <caption>전체, 제출, 반려, 수취완료, 회수 항목으로 구성</caption>
              <colgroup>
                <col style={{ width: '20%' }} />
                <col style={{ width: '20%' }} />
                <col style={{ width: '20%' }} />
                <col style={{ width: '20%' }} />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">전체</th>
                  <th scope="col">제출</th>
                  <th scope="col">반려</th>
                  <th scope="col">수취완료</th>
                  <th scope="col">회수</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {searchTabInfo.map((item, index) => (
                    <td key={index}>
                      <a
                        href="./"
                        onClick={(e) => {
                          e.preventDefault()
                          onSelected(e, 'tabStatus', item.id)
                        }}
                        title={item.title}
                      >
                        {'11' === item.id ? <strong className="text-red"> {item.count}</strong> : <strong> {item.count}</strong>}
                      </a>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="tbl-wrap mt40 mobile-scroll2 mobile-only">
          <table className="tbl-list">
            <caption>전체, 제출, 반려, 수취완료, 회수 항목으로 구성</caption>
            <colgroup>
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">전체</th>
                <th scope="col">제출</th>
                <th scope="col">반려</th>
                <th scope="col">수취완료</th>
                <th scope="col">회수</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {searchTabInfo.map((item, index) => (
                  <td key={index}>
                    <a
                      href="./"
                      onClick={(e) => {
                        e.preventDefault()
                        onSelected(e, 'tabStatus', item.id)
                      }}
                      title={item.title}
                    >
                      {'11' === item.id ? <strong className="text-red"> {item.count}</strong> : <strong> {item.count}</strong>}
                    </a>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

        {/* CertificateSentList.jsx */}
        <CertificateList
          data={printList}
          commoncode={props.commoncode}
          onSentDetail={onSentDetail}
          reload={props.readSentList}
          tabId={tabId}
          pagingInfo={pagingInfo}
          onSelected={onSelected}

          /* data={props.certboxList?.content}
              orgdata={props.certboxOrgList}
              commoncode={props.commoncode}
              onCertboxDetail={onCertboxDetail}
              onCertboxSubmit={onCertboxSubmit}
              onUploadDoc={onUploadDoc}
              reload={props.readcertboxList} 
              onSelected={onSelected}
              pagingInfo = {pagingInfo}
              tabId={tabId} */
        />

        <div className="list-footer">
          <Pagination pagingInfo={pagingInfo} onChange={(param) => searchList(searchInfo, param - 1)} />
        </div>
      </div>
      {/* //contents */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    soloSelectInfo: state.sent?.selectInfo,
    SentList: state.sent?.SentList?.list,
    countInfo: state.sent?.SentList?.count,
    commoncode: state.commoncode?.co,
    history: state.sent?.history,
  }
}

const actionCreators = {
  changeSearchInfo: sentActions.changeSearchInfo,
  openContracter: contracterActions.contracter,
  readSentList: sentActions.readSentList,       // 보낸문서함(송신함) 문서조회
  selectSentInfo: sentActions.selectSentInfo,
  common: commonActions.getCommonCode,
  settingHistory: sentActions.settingHistory,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(CertificateSentMain)
